var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.3418 54.3643C75.1193 54.3643 71.3883 56.442 69.1095 59.6144C66.8307 56.442 63.0997 54.3643 58.8995 54.3643C51.9513 54.3643 46.3213 59.9943 46.3213 66.9201C46.3213 82.6261 69.1095 92.0541 69.1095 92.0541C69.1095 92.0541 91.8977 82.6261 91.8977 66.9201C91.8977 59.9943 86.2677 54.3643 79.3418 54.3643Z",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4889 49.3595C85.757 47.4382 85.891 45.4945 85.891 43.5061C85.891 20.003 66.8338 0.945801 43.3084 0.945801C19.7829 0.945801 0.748047 20.003 0.748047 43.5061C0.748047 67.0092 19.8052 86.0887 43.3084 86.0887",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17969 38.9708C7.33608 39.1719 7.53715 39.3283 7.73822 39.4847L12.5193 42.6795C14.2396 43.8189 16.5631 42.9699 17.1216 41.0039L18.8195 35.1281C18.9536 34.6366 19.2217 34.1674 19.6015 33.81L24.7623 28.6491C24.9858 28.4257 25.2539 28.2246 25.5443 28.0682L29.0966 26.3032C30.3253 25.7 30.9956 24.3372 30.7275 22.9967L30.1466 20.1371C29.8562 18.7072 28.6051 17.7019 27.1752 17.7019H22.2378C21.1877 17.7019 20.227 17.1656 19.6685 16.272",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7582 76.4821L25.4347 70.2265C25.2113 69.6233 24.8538 69.1094 24.3623 68.7073L16.4311 61.8485C15.2917 60.8655 14.8449 59.2569 15.3141 57.8271L16.7886 53.3812C17.2354 51.996 18.4865 50.9906 19.9387 50.8566L30.5062 49.7842C31.8243 49.6501 33.1425 50.231 33.9021 51.3257L38.7725 58.2069C39.6438 59.4133 39.7108 61.0219 38.9512 62.3177L36.2032 66.92C35.8681 67.5009 35.6894 68.1934 35.6894 68.8413V77.063C35.6894 77.7779 35.466 78.4705 35.1085 79.0514",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5303 8.05028C35.4239 9.79291 37.2112 10.8653 39.1549 10.8653C39.4454 10.8653 39.7135 10.843 40.0262 10.7983L42.4615 10.3961C43.936 10.1503 45.2318 9.30138 46.0137 8.02792L46.5723 7.13428",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4541 48.3543V42.8359C61.4541 41.3837 62.3478 40.0656 63.6882 39.507L69.8098 36.9378C71.1949 36.3569 72.8035 36.6473 73.8759 37.6974L76.7803 40.5571C77.5399 41.2943 78.6123 41.6965 79.6847 41.6071",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2885 52.3088L40.3404 46.3436C39.335 45.4723 38.8658 44.1542 39.1339 42.836L39.8712 39.1274C40.0946 38.0103 40.8095 37.0496 41.8373 36.5581L45.3895 34.7708C48.1822 33.3856 48.0928 29.3865 45.2331 28.1131L44.831 27.9343C42.1724 26.7502 41.8819 23.1086 44.2948 21.5L52.0696 16.3168C52.293 16.1828 52.5164 16.0487 52.7398 15.9594L58.2135 13.7699C59.3082 13.3454 60.1125 12.4071 60.4253 11.29",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeIcon);
export default __webpack_public_path__ + "static/media/globe-icon.087fdda9.svg";
export { ForwardRef as ReactComponent };